<template lang="pug">
.setor
  h3.titulo {{ titulo }}
  el-row(:gutter="12").pesquisa
    el-col(:lg="8", :md="9", :sm="24")
      p.label Selecionar período:
      //- A tag form esta sendo usada para desabilitar o autofill do browser
      form
        el-date-picker.full-width.input(
          v-bind="$attrs",
          type="daterange",
          unlink-panels,
          placeholder="Selecione",
          range-separator="a",
          format="dd/MM/yyyy",
          start-placeholder="Data inicial",
          end-placeholder="Data final",
          v-model="filtro.dateRange",
          name='prazo',
          :picker-options='options'
          :clearable="false"
        )
    el-col(:lg="6", :md="5", :sm="24", v-if="!isRR")
      p.label Município:
      el-select.full-width.input(
        filterable,
        multiple,
        default-first-option=false,
        planceholder="Selecione"
        no-match-text="Nenhum município encontrado",
        name="municipio",
        collapse-tags,
        v-model="filtro.municipios",
        :clearable="false"
      )
        el-option(
          v-for="municipio in municipiosPA",
          :key="municipio.id",
          :label="municipio.nome",
          :value="municipio.id"
        )
    el-col(:lg="6", :md="5", :sm="24", v-if="!isRR")
      p.label Perfil:
      el-select.full-width.input(
        filterable,
        multiple,
        default-first-option=false,
        planceholder="Selecione"
        no-match-text="Nenhum perfil encontrado",
        v-model="filtro.perfis",
        collapse-tags,
        name="perfil",
        :clearable="false"
      )
        el-option(
          v-for="perfil in perfis",
          :key="perfil.codigo",
          :label="perfil.nome",
          :value="perfil.codigo"
        )
    el-col(:lg="4", :md="5", :sm="24", v-if="!isRR")
      p.label Ações:
      el-select.full-width.input(
        filterable,
        multiple,
        default-first-option=false,
        planceholder="Selecione"
        no-match-text="Nenhuma ação encontrada",
        v-model="filtro.acoes",
        collapse-tags,
        name="acao",
        :clearable="false"
      )
        el-option(
          v-for='acao in acoes',
          :key='acao.codigo',
          :label='acao.nome',
          :value='acao.codigo'
        )

  el-row
    .button-pesquisar
      el-button.margin-button(type="text", @click="limparPesquisa")
        |  Limpar filtro
      el-button.margin-button(type="primary", @click="pesquisar")
        i.icon(class="fa fa-search")
        |  Pesquisar

  el-row(:gutter="10").margin
    div(v-if="hasDados")
      el-col.width-100(:sm="24")
        el-card(shadow="hover").box-card
          slot(name="header")
            h3 Produtividade do setor
          div
            grafico-processo-por-analista(@produtividadePorAnalista="produtividadePorAnalista", :dadosLabels="produtividade.produtividadeServidores", :filtro="filtro")
      el-col(:lg="24", :md="24", v-if="!isRR")
        el-card(shadow="hover").box-card
          slot(name="header")
            h3 Produtividade dos servidores do setor
          div
            grafico-produtividade(:dadosLabels="produtividade.produtividadeServidores")
      el-col(:lg="24", :md="24", v-if="!isRR")
        el-card(shadow="hover").box-card
          slot(name="header")
            h3 Quantidade de processos por tipo
          div.teste
            grafico-quantidade-processo(:dadosLabels="produtividade.processosPorTipo")
      el-col.width-100(:sm="24", v-if="!isRR")
        el-card(shadow="hover").box-card
          slot(name="header")
            h3 Produtividade por período
          div
            grafico-rendimento(
              :dadosLabels="produtividade.produtividadePeriodoAnoMes ? produtividade.produtividadePeriodoAnoMes : produtividade.produtividadePeriodoAnoMesDia"
              :filtro = "filtro"
              :isProdutividadePeriodoAnoMes = "produtividade.produtividadePeriodoAnoMes ? true : false"
            )
      el-col.width-100(:sm="24", v-if="!isRR")
        div.container-map
          mapa-processos(v-if="!isLoading" :dadosLabels="produtividade.produtividadeProcessoLocalizacao")
      el-col.width-100(:sm="24", v-if="isRR && produtividade.processosAnalisados")
        app-modal-visualizar-completo(
          v-if="showModal"
          :showModal="showModal"
          @closeModal="showModal = false"
          :idProcesso="idProcesso"
          :protocolo="protocolo"
          :numeroProcesso="numeroProcesso"
          :tipo="tipoProcesso"
        )
        el-card.box-card(shadow="hover")
          slot(name="header")
            h3 Processos analisados
          el-table(
            :data='produtividade.processosAnalisados.content',
            v-loading="loading",
            element-loading-text="Carregando...",
            @sort-change="sort",
          )
            template(slot="empty") Não há registros.
            el-table-column(
              prop='numeroProcesso',
              label='Processo',
              width="auto",
              sortable
            )
            el-table-column(
              prop='setor',
              label='Setor',
              width="auto",
              sortable
            )
            el-table-column(
              prop='nomeRazaoSocialInteressado',
              label='Nome do interessado',
              width="auto",
              sortable
            )
            el-table-column(
              prop='nomeRazaoSocialUsuario',
              label='Técnico responsável',
              width="auto",
              sortable
            )
            el-table-column(
              prop='tipo',
              label='Tipo de processo',
              width="auto",
              sortable
            )
            el-table-column(
              prop='municipio',
              label='Município',
              width="auto",
              sortable
            )
            el-table-column(
              label='Ações',
              width='120',
              align='center'
            )
              template(slot-scope='scope')
                el-dropdown(trigger="click")
                  el-button(type='primary', size="small")
                    | Ações
                    i.el-icon-arrow-down.el-icon--right
                  el-dropdown-menu(slot='dropdown')
                    el-dropdown-item
                      .flex(@click="abreModal(scope.row)")
                        i.fa.fa-eye
                        | &nbsp Visualizar processo
          div.pagination
            app-paginacao(
              :total="produtividade.processosAnalisados.totalElements"
              :pagina="currentPage",
              @changePage="changePage",
              :tamanhoPagina="15"
            )
    div.flex(v-else)
      .border-top-bottom
        span.cinza Não existem resultados para serem exibidos.

  .margin
    el-button.btn(
      type="default"
      @click="voltar()"
    )
      i.fa.fa-chevron-left
      | &nbsp Voltar

</template>
<script>
import { mapActions } from 'vuex'
import GraficoQuantidadeProcesso from '@/screens/produtividade/components/GraficoQuantidadeProcesso'
import GraficoRendimento from '@/screens/produtividade/components/GraficoRendimento.vue'
import AppModalVisualizarCompleto from '@/screens/analise/components/modal/AppModalVisualizarCompleto.vue'
import AppPaginacao from '@/components/AppPaginacao'
import moment from 'moment'
import GraficoProcessoPorAnalista from '../produtividade/components/GraficoProcessoPorAnalista'
import GraficoProdutividade from '../produtividade/components/GraficoProdutividade'
import MapaProcessos from '@/screens/produtividade/components/MapaProcessos.vue'
const { nomesSetores } = require('@/utils/' + process.env.ESTADO + '/setor').default

export default {

  components: {
    GraficoProcessoPorAnalista,
    GraficoProdutividade,
    GraficoQuantidadeProcesso,
    MapaProcessos,
    GraficoRendimento,
    AppModalVisualizarCompleto,
    AppPaginacao
  },

  data () {
    return {
      filtro: {
        pagina: 0,
        analista: null,
        setor: this.$route.params.setor,
        dateRange: '',
        perfis: [],
        acoes: [],
        municipios: [],
        dataInicio: null,
        dataFim: null
      },
      isLoading: false,
      isRR: process.env.ESTADO === 'rr',
      perfis: [],
      setor: '',
      currentPage: 1,
      showModal: false,
      idProcesso: null,
      protocolo: null,
      numeroProcesso: null,
      loading: false,
      produtividade: [],
      acoes: [ { codigo: 'ANALISE', nome: 'Analisado' }, { codigo: 'VALIDACAO', nome: 'Validação' } ],
      idMunicipios: [],
      municipiosPA: [],
      dadosProdutividade: null,
      activeName: 'tabProdutividade',
      options: {
        shortcuts: [
          {
            text: 'Até Ontem',
            onClick (picker) {
              const end = new Date()
              const start = new Date('2019-1-1')
              end.setDate(end.getDate() - 1)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: 'Últimos 7 dias',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - (3600 * 1000 * 24 * 7))
              picker.$emit('pick', [start, end])
            }
          }, {
            text: 'Últimos 30 dias',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - (3600 * 1000 * 24 * 30))
              picker.$emit('pick', [start, end])
            }
          }, {
            text: 'Este Mês',
            onClick (picker) {
              const end = new Date()
              const start = new Date(end.getUTCFullYear(), end.getMonth(), 1)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: 'Último Mês',
            onClick (picker) {
              let start = new Date()
              let end = new Date()
              if (start.getMonth() === 0) {
                start = new Date(end.getUTCFullYear() - 1, 11, 1)
                end = new Date(end.getUTCFullYear() - 1, 12, 0)
              } else {
                start = new Date(end.getUTCFullYear(), end.getMonth() - 1, 1)
                end = new Date(end.getUTCFullYear(), end.getMonth(), 0)
              }
              picker.$emit('pick', [start, end])
            }
          }, {
            text: 'Último Ano',
            onClick (picker) {
              const date = new Date()
              const start = new Date(date.getUTCFullYear() - 1, 0, 1)
              const end = new Date(date.getUTCFullYear() - 1, 12, 0)
              picker.$emit('pick', [start, end])
            }
          }
        ],
        disabledDate (date) {
          return date > Date.now()
        }
      }
    }
  },

  async created () {
    this.getMunicipiosPA()
    if (this.filtro.setor === 'CDI') {
      this.perfis = await this.getPerfisBySetor(this.$route.params.setor = ['GIT', 'CDI'])
      this.filtro.setores = this.$route.params.setor = ['GIT', 'CDI', 'GIT_CDI', 'CDI_GIT']
    } else
    if (this.filtro.setor === 'CAF') {
      this.perfis = await this.getPerfisBySetor(this.$route.params.setor = ['CAF', 'TECNICO_DE_CAMPO'])
      this.filtro.setores = this.$route.params.setor = ['CAF', 'TECNICO_DE_CAMPO']
    } else
    if (this.filtro.setor === 'GPA') {
      this.perfis = await this.getPerfisBySetor(this.$route.params.setor = ['GPA', 'TECNICO_DE_CAMPO'])
      this.filtro.setores = this.$route.params.setor = ['GPA', 'TECNICO_DE_CAMPO']
    } else
    if (this.filtro.setor === 'GCQ') {
      this.perfis = await this.getPerfisBySetor(this.$route.params.setor = ['GCQ', 'TECNICO_DE_CAMPO'])
      this.filtro.setores = this.$route.params.setor = ['GCQ', 'TECNICO_DE_CAMPO']
    } else
    if (this.filtro.setor === 'GAM') {
      this.perfis = await this.getPerfisBySetor(this.$route.params.setor = ['GAM', 'TECNICO_DE_CAMPO'])
      this.filtro.setores = this.$route.params.setor = ['GAM', 'TECNICO_DE_CAMPO']
    } else {
      this.perfis = await this.getPerfisBySetor(this.$route.params.setor = [ this.$route.params.setor ])
      this.filtro.setores = this.$route.params.setor = this.$route.params.setor
    }
    this.getProdutividade(this.filtro)
  },

  methods: {
    ...mapActions({
      findProdutividade: 'produtividade/findProdutividade',
      findMunicipiosByEstadoAtual: 'municipios/findMunicipiosByEstadoAtual',
      getPerfisBySetor: 'usuario/findPerfisBySetor'
    }),

    async pesquisar () {
      if (this.filtro.dateRange) {
        this.filtro.dataInicio = moment(this.filtro.dateRange[0]).format('yyyy-MM-DD')
        this.filtro.dataFim = moment(this.filtro.dateRange[1]).format('yyyy-MM-DD')
      }

      this.getProdutividade(this.filtro)
    },

    async getMunicipiosPA () {
      this.municipios = await this.findMunicipiosByEstadoAtual()
      this.municipiosPA = this.municipios
    },

    produtividadePorAnalista (idUsuario, nomeRazaoSocial, idsServidores) {
      this.filtro.analista = nomeRazaoSocial
      this.filtro.idUsuario = idUsuario
      this.filtro.idsServidores = idsServidores
      this.$router.push({
        name: 'produtividadeSetorAnalista',
        query: {
          ...this.filtro
        }
      })
    },

    async getProdutividade () {
      this.isLoading = true
      this.produtividade = await this.findProdutividade(this.filtro)
      this.isLoading = false
    },

    voltar () {
      this.$router.push({
        name: 'produtividade'
      })
    },

    abreModal (row) {
      this.idProcesso = row.idProcesso
      this.protocolo = row.protocolo
      this.numeroProcesso = row.numeroProcesso
      this.tipoProcesso = row.codigo
      this.showModal = true
    },

    montaMunicipios () {
      this.filtro.municipios = []
      if (this.idMunicipios !== null) {
        this.idMunicipios.map(municipio => this.filtro.municipios.push({ id: municipio }))
      }
    },

    limparPesquisa () {
      this.filtro = {
        setor: this.$route.params.setor,
        setores: this.$route.params.setor,
        pagina: 0,
        dateRange: null,
        municipios: [],
        perfis: [],
        acoes: [],
        dataInicio: null,
        dataFim: null
      }

      this.getProdutividade()
    }
  },

  computed: {

    titulo () {
      const setor = this.filtro.setor === 'TECNICO_DE_CAMPO' ? 'TECNICO DE CAMPO' : this.filtro.setor
      return `${setor} - ${nomesSetores[this.filtro.setor]}`
    },

    api () {
      if (process.env.NODE_ENV === 'development') {
        return 'api/'
      }
      return ''
    },

    hasDados () {
      return (this.produtividade.processosPorTipo && this.produtividade.processosPorTipo.length > 0) ||
      (this.produtividade.produtividadePeriodo && this.produtividade.produtividadePeriodo.length > 0) ||
      (this.produtividade.produtividadeServidores && this.produtividade.produtividadeServidores.length)
    }

  }
}
</script>
<style lang="scss" scoped>

  .pesquisa {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
  }

  .container-map {
    position: relative;
    padding: 2% 0%;
  }

  #map {
    height: 70vh;
    z-index: 1;
    border-radius: 12px;
  }

  .titulo {
    color: #e5f137;
    font-weight: bold;
    font-size: 20px;
    margin-top: 0px;
  }

  .margin {
    margin-top: 20px;
  }

  .full-width {
    width: 100%;
  }

  .margin-bottom {
    margin-bottom: 20px;
  }

  .div-total {
    padding: 2% 0 0 2%;
    font-size: 14px;
  }

  .box-card {
    margin: 10px 0;
    border-radius: 12px;
  }

  .setor {
    padding: 2% 11% 2% 11%
  }
  .button-pesquisar {
    display: flex;
    justify-content: space-between;
    margin-top: 2%;
  }

  .cinza {
    color: #c0c4cc;
  }

  .flex {
    display: flex;
    justify-content: center;
  }

  .border-top-bottom {
    padding-left: 20vw;
    padding-right: 20vw;
    padding-top: 25px;
    padding-bottom: 25px;
    border-top: solid 1px #c0c4cc;
    border-bottom: solid 1px #c0c4cc;
  }

  @media only screen and (max-width: 1500px) {
    .width-100.el-col {
      width: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/screens/produtividade/ProdutividadeSetor.vue